var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForwardBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Forward",
    transform: "translate(-1501 -352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Base",
    transform: "translate(1501 352)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-round-forward",
    "data-name": "Icon ionic-ios-arrow-round-forward",
    d: "M19.354,11.482a.817.817,0,0,0-.006,1.15l3.8,3.808H8.682a.813.813,0,0,0,0,1.626H23.143l-3.8,3.808a.823.823,0,0,0,.006,1.15.809.809,0,0,0,1.144-.006l5.152-5.189h0a.913.913,0,0,0,.169-.256.776.776,0,0,0,.063-.313.815.815,0,0,0-.231-.569L20.492,11.5A.8.8,0,0,0,19.354,11.482Z",
    transform: "translate(1496.125 346.748)",
    fill: "#347af0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardBlue);
export default __webpack_public_path__ + "static/media/forwardBlue.14b77b478ddac0a0a8766822d8a6dc98.svg";
export { ForwardRef as ReactComponent };